module.exports = __webpack_public_path__ + "static/media/live 16_10_2019.759dd203.jpg";